// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"41dfd2d3","285":"92e4e634","513":"7726ef21","718":"8c90453c","990":"77e2f641"}[chunkId] + ".chunk.js";
};